import React, { useReducer } from "react";
import plataformaTenantReducer from "./plataformaTenantReducer";
import plataformaTenantContext from "./plataformaTenantContext";

import {
    getAllPlataformaTenants as getAllPlataformaTenantAPI,
    getPlataformasByTenantId as getPlataformasByTenantIdAPI,
    addPlataformaTenant as addPlataformaTenantAPI,
    updatePlataformaTenant as updatePlataformaTenantAPI,
    deletePlataformaTenant as deletePlataformaTenantAPI
} from "../../api/plataformaTenant";

import {
    GET_PLATAFORMA_TENANTS,
    GET_PLATAFORMAS_BY_TENANT,
    ADD_PLATAFORMA_TENANT,
    UPDATE_PLATAFORMA_TENANT,
    DELETE_PLATAFORMA_TENANT,
    SET_LOADING,
    SET_ERROR,
    CLEAR_PLATAFORMAS_TENANT
} from "./plataformaTenantActions";

const PlataformaTenantState = props => {

    const initialState = {
        plataformaTenants: [],
        plataformasByTenant: [],
        loading: false,
        error: null
    };

    const [state, dispatch] = useReducer(plataformaTenantReducer, initialState);

    const getAllPlataformaTenants = async () => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await getAllPlataformaTenantAPI();
            dispatch({
                type: GET_PLATAFORMA_TENANTS,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en getAllPlataformaTenants", error);
            dispatch({ type: SET_ERROR, payload: error.message });
        }
    };

    const getPlataformasByTenantId = async (tenantId) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await getPlataformasByTenantIdAPI(tenantId);
            dispatch({
                type: GET_PLATAFORMAS_BY_TENANT,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en getPlataformasByTenantId", error);
            dispatch({ type: SET_ERROR, payload: error.message });
        }
    };

    const addPlataformaTenant = async (plataformaTenant) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await addPlataformaTenantAPI(plataformaTenant);
            dispatch({
                type: ADD_PLATAFORMA_TENANT,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en addPlataformaTenant", error);
            dispatch({ type: SET_ERROR, payload: error.message });
            throw error;
        }
    };

    const updatePlataformaTenant = async (id, updates) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await updatePlataformaTenantAPI(id, updates);
            dispatch({
                type: UPDATE_PLATAFORMA_TENANT,
                payload: response.data.data
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en updatePlataformaTenant", error);
            dispatch({ type: SET_ERROR, payload: error.message });
            throw error;
        }
    };

    const deletePlataformaTenant = async (plataformaTenant) => {
        try {
            dispatch({ type: SET_LOADING, payload: true });
            const response = await deletePlataformaTenantAPI(plataformaTenant._id);
            dispatch({
                type: DELETE_PLATAFORMA_TENANT,
                payload: plataformaTenant
            });
            return response.data.data;
        } catch (error) {
            console.log("Error en deletePlataformaTenant", error);
            dispatch({ type: SET_ERROR, payload: error.message });
            throw error;
        }
    };

    const clearPlataformasTenant = () => {
        dispatch({ type: CLEAR_PLATAFORMAS_TENANT });
    };

    return (
        <plataformaTenantContext.Provider
            value={{
                plataformaTenants: state.plataformaTenants,
                plataformasByTenant: state.plataformasByTenant,
                loading: state.loading,
                error: state.error,
                getAllPlataformaTenants,
                getPlataformasByTenantId,
                addPlataformaTenant,
                updatePlataformaTenant,
                deletePlataformaTenant,
                clearPlataformasTenant
            }}
        >
            {props.children}
        </plataformaTenantContext.Provider>
    );
};

export default PlataformaTenantState;
